export default "__VITE_ASSET__B84X6n8z__"